import { render, staticRenderFns } from "./ManteCartaProducto.vue?vue&type=template&id=4f0d1b6e&"
import script from "./ManteCartaProducto.vue?vue&type=script&lang=js&"
export * from "./ManteCartaProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports